import React, { useState } from 'react'
import { Col, Container, Modal, Row } from 'react-bootstrap'
import { FaHandsHelping, FaPlay } from 'react-icons/fa'
import { GoArrowUpRight } from 'react-icons/go';
import { Link } from 'react-router-dom';

function VideoPart() {
    const [show, setShow] = useState(false);
    return (
        <div className='home-gap home-video-part'>
            <Container>
                <Row className='gy-4'>
                    <Col className="col-12 col-lg-6" data-aos="fade-right">
                        <div className='main-video-part-container'>
                            <div className='sub-video-part-container'>
                                <img src={require('../../assets/images/1ad69f50bb1e2e438e6a99d15a737afc.png')} alt="" />
                                <button onClick={() => setShow(true)} className='play-part'><FaPlay className='fs-35 fs-lg-25 fs-sm-20 ms-1 ms-md-2 mt-md-1' /></button>
                            </div>
                        </div>
                    </Col>
                    <Col className="col-12 col-lg-6 d-grid align-content-center gap-3 gap-md-4 gap-lg-5 ps-lg-3" data-aos="fade-left">
                        <div className='d-grid gap-2 gap-md-3'>
                            <h1 className='fw-semibold m-0 fs-sm-25'>We are Manufacturer</h1>
                            <p className='m-0 fs-18 fs-md-16 fs-sm-14'>Nexus Paper Packs is a leading manufacturer of Ripple Wall, Double Wall, and Single Wall paper cups. We focus on innovative designs, top-quality production, and sustainable practices to meet your packaging needs.
                            </p>
                            {/* <p className='m-0 fs-18 fs-md-16 fs-sm-14'>Nexus Paper Packs is a leading manufacturer of Ripple Wall, Double Wall, and Single Wall paper cups. We focus on innovative designs, top-quality production, and sustainable practices to meet your packaging needs.</p> */}
                        </div>
                        <div className='d-flex'>
                            <Link to={"/about-us"} className='new-theme-contra-btn'>
                                Read More About us
                                <span><GoArrowUpRight /></span>
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Modal
                show={show}
                onHide={() => setShow(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='custom-home-video-modal'
            >
                <Modal.Body>
                    <div>
                        <video src={require('../../assets/videos/8164413-uhd_4096_2160_25fps.mp4')} height={"100%"} width={"100%"} autoPlay controls loop></video>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default VideoPart